module.exports = __webpack_public_path__ + "img/pedo.09b4b306.jpg";